module.exports = __webpack_public_path__ + "static/media/notifications-ico.2720215b.svg";